/**
 * LOSEFORD ギフトボックス & カート導線
 * 仕様: 松本様 2026-08-26 のご指示（モック「LOSEFORD_カート導線_ギフトモック.html」）を
 *       2026-09-02 のご指示で更新（ギフトを独立した商品として扱う）
 *
 * ■ ギフト
 *   ギフトはカートの1行として持つ。3画面（商品ページ / CART INポップアップ / カートページ）は
 *   同じ行を見て・書き換えるだけなので、状態は常に同期し、二重追加も起きない。
 *
 *   松本様ご指示 2026-09-02:
 *     ・ギフトボックスは単体でも購入可能（カートに商品が無くても追加できる）
 *     ・数量は自由（商品数による上限なし）
 *     ・商品を削除してもギフトはカートに残る（連動して消さない）
 *   これに伴い、以前の「上限（cap）＝表示している商品の数量」「超過分の自動減算」
 *   「商品が入るまでカートに書かない保留」の3つの仕組みは撤去した。
 *
 * ■ カート導線
 *   CART INポップアップには「今追加した商品」だけを残す。
 *   ほかにも入っている場合は「カートには他に N 点あります」を添える。
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LAST_ADDED_KEY = 'lf:lastAdded';
  var cartCache = null;
  var busy = false;
  var queued = false;

  // ───────────────────────────────────────────── 小道具
  function yen(cents) {
    return '¥' + Number(Math.round(cents) / 100).toLocaleString('ja-JP');
  }

  // カートを何回書き換えたかの版数。取得の応答が古いかどうかの判定に使う。
  var cartVersion = 0;

  /** カートを取り直す
   *
   *  松本様ご指摘 2026-09-07:「＋を押しても増えない／金額が変わらない」
   *
   *  取りに行っている最中に自分が書き込むと、あとから届いた「書き込み前の
   *  カート」で新しい値を上書きしてしまうことがある。そうなると次に押したとき、
   *  古い個数を元に「+1」するので同じ値を書き直すことになり、
   *  押した1回分がそのまま消える（実測: 2回押しても2個のまま）。
   *  取りに行く前の版数を覚えておき、戻ってきたときに版が進んでいたら捨てる。
   */
  function getCart(force) {
    if (cartCache && !force) return Promise.resolve(cartCache);
    var startedAt = cartVersion;
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (startedAt === cartVersion) cartCache = c;
        return cartCache || c;
      });
  }

  function readLastAdded() {
    try { return JSON.parse(sessionStorage.getItem(LAST_ADDED_KEY) || 'null'); } catch (e) { return null; }
  }

  function writeLastAdded(v) {
    try { sessionStorage.setItem(LAST_ADDED_KEY, JSON.stringify(v)); } catch (e) { /* プライベートモード等 */ }
  }

  function giftIds() {
    var ids = [];
    document.querySelectorAll('[data-lf-gift]').forEach(function (el) {
      var id = Number(el.getAttribute('data-variant-id'));
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function findGiftLine(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === id) return cart.items[i];
    }
    return null;
  }

  function countExcludingGift(cart, id) {
    var n = 0;
    cart.items.forEach(function (it) { if (it.variant_id !== id) n += it.quantity; });
    return n;
  }

  // ───────────────────────────────────────────── カートの書き換え
  //
  // ＋を続けて押しても取りこぼさないよう、画面は先に更新し、
  // カートへの書き込みは最後の値だけをまとめて1回行う。
  var pendingQty = null;   // 目標個数（未反映）
  var pendingId = null;
  var writeTimer = null;
  var firstPendingAt = 0;  // 最初の未反映が出た時刻（連打中の書き込み間隔に使う）
  var MAX_WAIT = 500;      // 押し続けていても、これ以上は書き込みを待たせない

  function currentQty(id) {
    if (pendingQty !== null && pendingId === id) return pendingQty;
    var line = cartCache ? findGiftLine(cartCache, id) : null;
    return line ? line.quantity : 0;
  }

  // 松本様ご指示 2026-09-02: ギフトは単体でも購入できる独立した商品になったので、
  // 「商品が入るまでカートに書かない」保留の仕組みは不要になった。
  // チェックした時点でそのままカートへ書き込む。
  //
  // 松本様ご指摘 2026-09-07:「封筒の枚数を増やしても下の金額が増えない」
  //   以前は押すたびに 260ms の待ちを引き直していたため、連打している間は
  //   一度も書き込まれず、個数だけが増えて金額が止まって見えた
  //   （実測: 20回押した3.3秒のあいだ、カートは1個のまま）。
  //   待ちは引き直すが、最初の未反映から MAX_WAIT を超えたら必ず書く。
  //   連打中も 0.5秒ごとに金額が追いつく。
  function setGift(id, qty) {
    pendingId = id;
    pendingQty = Math.max(0, qty);
    render();
    if (!firstPendingAt) firstPendingAt = Date.now();
    clearTimeout(writeTimer);
    var wait = Math.min(260, Math.max(0, firstPendingAt + MAX_WAIT - Date.now()));
    writeTimer = setTimeout(flush, wait);
  }

  function flush() {
    if (pendingQty === null) return;
    if (busy) { writeTimer = setTimeout(flush, 150); return; }
    var id = pendingId;
    var qty = pendingQty;
    busy = true;
    firstPendingAt = 0;

    // 松本様ご指摘 2026-08-29:「梱包数を1つ増やすたびに0.5秒ほど遅れる」
    //
    // 以前はここで GET → POST → GET と3往復していた（実測: ＋1回で 1.19秒）。
    // 往復は書き込みの POST 1回で足りる。
    //   ・行の key は cartCache から取れる。直前の flush / sync で最新になっている
    //   ・cart/change.js は更新後のカート全体を返すので、取り直す必要がない
    // cartCache がまだ無いときと、cart/add.js（追加行しか返さない）のときだけ取得する。
    var pre = cartCache ? Promise.resolve(cartCache) : getCart(true);

    pre
      .then(function (cart) {
        var line = findGiftLine(cart, id);
        if (!line && qty <= 0) return null;
        if (!line) {
          return fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
          }).then(function (r) { return r.ok ? 'added' : 'failed'; });
        }
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: qty }),
        }).then(function (r) { return r.ok ? r.json() : 'failed'; });
      })
      .then(function (res) {
        // 書き込みが済んだので版を進める。これより前に始まった取得の応答は捨てられる。
        cartVersion += 1;
        // change.js の戻りはカート全体（item_count を持つ）。それ以外は取り直す。
        if (res && typeof res.item_count === 'number' && Array.isArray(res.items)) {
          cartCache = res;
          return res;
        }
        return getCart(true);
      })
      .then(function () {
        busy = false;
        // 書き込んだ値がカートに乗ったら、未反映の目標は捨てる
        if (pendingQty === qty && pendingId === id) { pendingQty = null; pendingId = null; }
        notifyCartUpdated();
        render();
        filterDrawerItems();
        if (pendingQty !== null) flush();
      })
      .catch(function () {
        // 失敗したまま画面だけ新しい個数を出し続けないよう、カートを取り直して描き直す
        busy = false; pendingQty = null; pendingId = null;
        getCart(true).then(function () { render(); }).catch(function () {});
      });
  }

  /** テーマ側のカート表示（ドロワー・合計）を更新させる
   *
   *  松本様ご指摘 2026-09-07:「商品の枚数を増やそうとしたら固まって増やせない」
   *
   *  以前はギフトを1つ書き換えるたびに cart:build を投げていた。
   *  テーマはこれを受けて商品一覧を丸ごと取り直して差し替えるため、
   *  その間（実測 約800ms）は行の＋が pointer-events:none になり押せない。
   *  連打すると押せない時間が続き、商品の数量が増やせなくなっていた。
   *
   *  ギフトは商品一覧に出していないので（R-21）、ギフトだけの変更で
   *  一覧が変わることはない。作り直しは不要で、必要なのは金額の表示だけ。
   *  そこで金額はこちらで直接書き換え、重い作り直しは操作が落ち着いてから1回だけ行う
   *  （カート全体の割引など、こちらで面倒を見きれない表示を最後に整えるため）。
   */
  var selfEvent = 0;
  var rebuildTimer = null;

  /** 金額表示だけを、いま持っているカートの内容で書き換える */
  function paintTotals(cart) {
    if (!cart) return;
    var money = null;
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      money = theme.Currency.formatMoney(cart.total_price, theme.settings && theme.settings.moneyFormat);
    }
    if (money) {
      document.querySelectorAll('[data-subtotal]').forEach(function (el) { el.innerHTML = money; });
    }
    // ヘッダーのカートの印
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });
  }

  function notifyCartUpdated() {
    paintTotals(cartCache);
    selfEvent += 1;
    // 送料無料バーは cart:updated を購読している（snippets/free-shipping.liquid）。
    // ここで updateFreeShippingMessage() も呼ぶと cart.js を2回取りに行くので呼ばない。
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartCache } }));
    selfEvent -= 1;

    // 操作が落ち着いたら、テーマ側にも1回だけ作り直させる
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(function () {
      selfEvent += 1;
      document.dispatchEvent(new CustomEvent('cart:build'));
      selfEvent -= 1;
    }, 1200);
  }

  // ───────────────────────────────────────────── 表示の更新
  function render() {
    var boxes = document.querySelectorAll('[data-lf-gift]');
    if (!boxes.length || !cartCache) return;

    boxes.forEach(function (el) {
      var id = Number(el.getAttribute('data-variant-id'));
      var price = Number(el.getAttribute('data-price')) || 0;
      var priceText = el.getAttribute('data-price-text') || yen(price);
      var scope = el.getAttribute('data-scope');
      var qty = currentQty(id);

      var input = el.querySelector('[data-lf-gift-input]');
      var stepper = el.querySelector('[data-lf-gift-stepper]');
      var qtyEl = el.querySelector('[data-lf-gift-qty]');
      var noteEl = el.querySelector('[data-lf-gift-note]');
      var priceEl = el.querySelector('[data-lf-gift-price]');
      var nameEl = el.querySelector('[data-lf-gift-name]');
      var plus = el.querySelector('[data-lf-gift-plus]');

      var on = qty > 0;
      el.classList.toggle('is-on', on);
      if (input) input.checked = on;

      if (stepper) stepper.hidden = !on;
      if (qtyEl) qtyEl.textContent = String(qty);

      // 松本様ご指摘 2026-08-27 の文言。未チェックのときに「もう入っている」と
      // 読まれないよう、能動的な言い方にそろえる。
      //   未チェック … 「ギフトバッグ＆ボックスを追加する」「+¥500」
      //                 「チェックで追加（個数も選べます）」
      //   チェック後 … 「ギフトバッグ＆ボックス」「追加済み」「+¥500 × N」
      if (on) {
        if (nameEl) nameEl.textContent = nameEl.getAttribute('data-label-on') || 'ギフトバッグ＆ボックス';
        if (noteEl) noteEl.textContent = '+' + priceText + ' × ' + qty;
        if (priceEl) priceEl.textContent = '追加済み';
        if (priceEl) priceEl.classList.add('lf-gift__price--added');
      } else {
        if (nameEl) {
          nameEl.textContent =
            nameEl.getAttribute('data-label-off') || 'ギフトバッグ＆ボックスを追加する';
        }
        if (noteEl) {
          noteEl.textContent =
            noteEl.getAttribute('data-default') || 'チェックで追加（個数も選べます）';
        }
        if (priceEl) priceEl.textContent = '+' + priceText;
        if (priceEl) priceEl.classList.remove('lf-gift__price--added');
      }

      // 松本様ご指示 2026-09-02: 数量に上限を設けないので「＋」は常に押せる。
      // 以前の無効化状態が残らないよう、明示的に解除しておく。
      if (plus) {
        plus.disabled = false;
        plus.classList.remove('is-disabled');
        plus.setAttribute('aria-disabled', 'false');
      }
      el.removeAttribute('data-cap');
    });
  }

  /** カートが空になったら CART INポップアップ自体を閉じる
   *
   *  松本様ご指摘 2026-08-27:「全ての商品を削除したときにカート内が表示されるのが
   *  気になる。ポップアップ自体が消えるようにできますか」。
   *  Impulse は空になると中身を『カートは空です』に差し替えて開いたままにするため、
   *  ✕ と同じ経路（js-drawer-close）で閉じる。
   *
   *  松本様ご指示 2026-09-02: ギフトボックスは単体でも買える独立した商品になった。
   *  商品を消してもギフトはカートに残るので、「商品0点」ではなく
   *  「カートが本当に空（item_count 0）」を閉じる条件にする。
   *  ギフトだけが残っている状態で閉じてしまうと、買える中身を隠すことになる。
   */
  // 「中身があった → 無くなった」を見届けてから閉じる。
  //
  // 直前の実測: カートに追加した直後、テーマがポップアップを開いた 1秒後に
  // 中身がまだ届いていない（＝0点）状態で閉じてしまっていた。
  // 一度も中身を見ていないうちは、0 でも「まだ届いていない」とみなす。
  var sawItems = false;

  function closeDrawerIfEmpty() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    if (!cartCache) return;
    if (pendingQty !== null || busy) return;   // 書き込み中の一瞬で閉じない
    if (cartCache.item_count > 0) { sawItems = true; return; }
    // 行がまだ描かれている間は、カートの取得が追いついていないだけ。
    if (drawer.querySelectorAll('.cart__item').length > 0) return;
    if (!sawItems) return;
    var close = drawer.querySelector('.js-drawer-close');
    if (close) close.click();
  }

  /** お知らせポップアップに CART IN を横取りさせない
   *
   *  実測: カートに追加した直後、テーマのニュースレターポップアップが開くと
   *  Impulse が他のドロワーを閉じるため、CART INポップアップが消えていた。
   *  （お知らせポップアップは初回訪問時に出るので、いちばん大事な初回の追加で起きる）
   *
   *  松本様ご指摘 2026-08-31:「商品の数を増やそうとすると画面が固まる。
   *  ページが再読み込みされるような感じ」「価格の計算が行われていない」。
   *
   *  以前は「開いてしまったお知らせを閉じて CART IN を開き直す」後追いだったため、
   *  CART IN が 190ms ほど消えて開き直る。実測すると、その間にテーマが走らせる
   *  カートの描き直しと重なり、小計が1つ前の値のまま残ることがあった。
   *  （お知らせを止めて測ると、小計は毎回ぴたりと合う）
   *
   *  そこで後追いをやめ、開かせない。CART IN が開いている間は
   *  お知らせポップアップの自動表示だけを先送りし、閉じたあとに出す。
   *  ボタンから開いた（evt がある）ときはお客様の操作なのでそのまま通す。
   */
  function guardCartInPopup() {
    var modal = document.querySelector('.modal[data-section-type="newsletter-popup"]');
    if (!modal) return;
    var deferredModal = null;   // 先送りしたお知らせ（Modal インスタンス）
    var deferred = false;       // 後追い経路で引っ込めたかどうか
    var reopenAt = 0;           // 先送り分を自分で出した時刻（②に横取りと誤認させない）

    function drawerOpen() {
      var el = document.getElementById('CartDrawer');
      return !!el && el.classList.contains('drawer--is-open');
    }

    // ① 予防：CART IN が開いている間は、お知らせポップアップを開かせない。
    //    Impulse は open() の中で他のドロワーを閉じるので、開いてから閉じ直すと
    //    CART IN が一瞬消える。開かせなければ、ちらつきも描き直しの取りこぼしも起きない。
    //
    //    この差し替えは theme.Modals が定義されてからでないと効かない。
    //    layout/theme.liquid では loseford-assets（30行目）が theme.js（87行目）より先で、
    //    defer 付きは記述順に走るため、このファイルのほうが先に動く。
    //    そのうえ defer の実行時点は readyState が 'interactive' なので、
    //    start() は DOMContentLoaded を待たずその場で走っている。
    //    つまり最初の一回では theme.Modals はまだ無い。用意できるまで待って掛ける。
    //    お知らせの自動表示は数秒後なので、これで十分間に合う。
    (function installDeferGuard(tries) {
      if (window.theme && theme.Modals && theme.Modals.prototype) {
        if (theme.Modals.prototype.lfDeferGuard) return;
        var themeOpen = theme.Modals.prototype.open;
        theme.Modals.prototype.open = function (evt) {
          var el = this.modal;
          var isNews = el && el.getAttribute('data-section-type') === 'newsletter-popup';
          // 自動表示（evt なし）だけを止める。お客様がボタンで開いたときは通す。
          if (isNews && !evt && drawerOpen()) { deferredModal = this; return; }
          return themeOpen.apply(this, arguments);
        };
        theme.Modals.prototype.lfDeferGuard = true;
        return;
      }
      if (tries > 100) return;   // 5秒あきらめる（②の後追いが受け持つ）
      setTimeout(function () { installDeferGuard(tries + 1); }, 50);
    })(0);

    // ② 後追い（保険）：①が間に合わなかった場合に、開いてしまったお知らせを引っ込める。
    //
    //    以前は「CART IN が開いてから1秒以内」を横取りの目印にしていたが、
    //    お知らせは追加から2〜3秒後に出ることもあり、その場合は目印を外して
    //    CART IN が閉じたままになっていた（実測: 開いて1.3秒後に横取り → 復帰せず）。
    //    Impulse は横取りの瞬間にドロワーを閉じるので、
    //    「たった今 CART IN が閉じたか」で見るほうが確実。
    var lastCloseAt = 0;
    var watched = document.getElementById('CartDrawer');
    if (watched) {
      new MutationObserver(function () {
        if (!watched.classList.contains('drawer--is-open')) lastCloseAt = Date.now();
      }).observe(watched, { attributes: true, attributeFilter: ['class'] });
    }
    function justStolen() { return Date.now() - lastCloseAt < 600; }

    new MutationObserver(function () {
      if (!modal.classList.contains('modal--is-active')) return;
      // ③で先送り分を出した直後は、自分が開けたもの。横取りではないので触らない。
      // （これを見落として②が引っ込め、CART IN を開き直してしまう不具合があった）
      if (Date.now() - reopenAt < 2000) return;
      if (!drawerOpen() && !justStolen()) return;
      var close = modal.querySelector('.js-modal-close');
      if (!close) return;
      deferred = true;
      close.click();
      var tries = 0;
      (function reopenSoon() {
        setTimeout(function () {
          if (drawerOpen()) return;
          if (tries >= 4) return;
          tries += 1;
          var reopen = document.querySelector('[data-lf-cart-reopen]');
          if (reopen) reopen.click();
          reopenSoon();
        }, 180);
      })();
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });

    // ③ CART IN を閉じたら、先送りしていたお知らせを出す。
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('drawer--is-open')) return;
      if (deferredModal) {
        var m = deferredModal; deferredModal = null;
        setTimeout(function () {
          if (drawerOpen()) return;
          reopenAt = Date.now();
          m.open();
        }, 600);
        return;
      }
      if (!deferred) return;
      deferred = false;
      setTimeout(function () {
        if (drawerOpen()) return;
        var el = document.getElementById(modal.id);
        if (el) el.classList.add('modal--is-active');
      }, 600);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function sync() {
    return getCart(true).then(function () {
      return Promise.resolve();
    }).then(function () {
      render();
      filterDrawerItems();
      closeDrawerIfEmpty();
    });
  }

  // テーマはひとつの操作で cart:build / cart:updated を続けて投げ、そのうえ
  // ドロワーの描き直しでも監視が走る。素直に毎回 cart.js を取りに行くと
  // 1操作で何度も取得してしまうので、最後の1回にまとめる。
  var syncTimer = null;
  function syncSoon() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { sync(); }, 90);
  }

  // ───────────────────────────────────────────── CART INポップアップ
  /**
   * ポップアップは「今追加した商品」だけを残す。
   * ほかにも入っていれば「カートには他に N 点あります」を添える。
   */
  /**
   * 行の出し入れだけを、カートを取りに行かずその場で決める。
   *
   * 松本様ご指摘 2026-08-27:「数量を変更すると、カート画面が一瞬表示される」。
   * 数量を触るとテーマが [data-products] を丸ごと描き直す。以前はそのあと
   * cart.js を取りに行ってから隠していたので、取得を待つ数百ミリ秒だけ
   * 「カート全体」がそのまま見えていた（これがチラつきの正体）。
   * 描き直しを検知した時点で、DOMの情報だけで同期的に隠す。
   */
  function applyRowVisibility() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return null;
    var wrap = drawer.querySelector('[data-products]');
    if (!wrap) return null;
    var rows = wrap.querySelectorAll('.cart__item');
    if (!rows.length) return null;

    var la = readLastAdded();
    var ids = giftIds();
    var shown = 0;
    var hiddenIds = [];

    rows.forEach(function (row) {
      var variantId = Number((row.getAttribute('data-key') || '').split(':')[0]);
      var isGift = ids.indexOf(variantId) !== -1;
      var isLast = la && la.variantId === variantId;
      // ギフトは別枠（ギフトボックス）で見せるので商品行には出さない
      var keep = !isGift && (!la || isLast);
      row.hidden = !keep;
      row.classList.toggle('lf-cart-item--hidden', !keep);
      if (keep) shown++;
      else if (!isGift) hiddenIds.push(variantId);
    });

    // 直近の追加が特定できず全部隠れてしまう事故を防ぐ
    if (shown === 0) {
      rows.forEach(function (row) {
        var variantId = Number((row.getAttribute('data-key') || '').split(':')[0]);
        if (ids.indexOf(variantId) === -1) {
          row.hidden = false;
          row.classList.remove('lf-cart-item--hidden');
        }
      });
      hiddenIds = [];
    }
    return hiddenIds;
  }

  function filterDrawerItems() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cartCache) return;
    var wrap = drawer.querySelector('[data-products]');
    if (!wrap) return;

    var hiddenIds = applyRowVisibility();
    if (hiddenIds === null) return;

    var ids = giftIds();
    var hiddenQty = 0;
    hiddenIds.forEach(function (variantId) {
      cartCache.items.forEach(function (it) {
        if (it.variant_id === variantId) hiddenQty += it.quantity;
      });
    });

    var note = drawer.querySelector('[data-lf-cart-more]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'lf-cart-more';
      note.setAttribute('data-lf-cart-more', '');
      wrap.parentNode.insertBefore(note, wrap.nextSibling);
    }
    note.textContent = hiddenQty > 0 ? 'カートには他に ' + hiddenQty + ' 点あります' : '';
    note.hidden = hiddenQty <= 0;

    // 小計は常にカート全体。何点分の合計かを添える
    var label = drawer.querySelector('.ajaxcart__subtotal');
    if (label) {
      var total = countExcludingGift(cartCache, ids[0] || 0);
      var giftLine = findGiftLine(cartCache, ids[0] || 0);
      var giftQty = giftLine ? giftLine.quantity : 0;
      label.textContent = '小計（カート全 ' + (total + giftQty) + ' 点）';
    }
  }

  // ───────────────────────────────────────────── 入力
  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-lf-gift-input]') : null;
    if (!input) return;
    var el = input.closest('[data-lf-gift]');
    if (!el) return;
    var id = Number(el.getAttribute('data-variant-id'));

    // 画面を開いた直後、カートを取り終える前は枠が「未チェック」に見える。
    // その一瞬に押されると、すでに入っている個数を 1 に書き潰してしまう。
    // カートを確かめてから決める（チェック＝すでに入っていればその数のまま）。
    if (!cartCache) {
      getCart(true).then(function () {
        if (!input.checked) { setGift(id, 0); return; }
        var now = currentQty(id);
        setGift(id, now > 0 ? now : 1);
      }).catch(function () { setGift(id, input.checked ? 1 : 0); });
      return;
    }

    if (input.checked) {
      var now = currentQty(id);
      setGift(id, now > 0 ? now : 1);
    } else {
      setGift(id, 0);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var minus = t.closest('[data-lf-gift-minus]');
    var plus = t.closest('[data-lf-gift-plus]');
    if (!minus && !plus) return;
    e.preventDefault();
    e.stopPropagation();

    var el = (minus || plus).closest('[data-lf-gift]');
    if (!el || !cartCache) return;
    var id = Number(el.getAttribute('data-variant-id'));
    var qty = currentQty(id);

    if (plus) {
      setGift(id, qty + 1);
    } else {
      setGift(id, Math.max(0, qty - 1));
    }
  });

  // ギフトは商品の数量に連動しなくなったため、商品ページの数量入力は監視しない。
  // カート内で数量を触ったときは、小計の「カート全 N 点」を合わせ直すために取り直す。
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.js-qty__adjust')) return;
    setTimeout(function () { sync(); }, 150);
  });

  // 追加した商品を覚えておく（ポップアップの絞り込みに使う）
  document.addEventListener('ajaxProduct:added', function (e) {
    var d = e.detail && e.detail.product;
    var item = d && d.items ? d.items[0] : d;
    if (item && item.variant_id) {
      writeLastAdded({ variantId: item.variant_id, quantity: item.quantity, at: Date.now() });
    }
    setTimeout(function () { sync(); }, 200);
  });

  ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      // まず同期的に行を整える（待ってから隠すとカート全体が一瞬見える）。
      applyRowVisibility();
      // 自分が flush の最後に投げたイベントなら、カートは今取ったばかりで
      // render も済んでいる。ここで取り直すと1往復の無駄になる。
      if (selfEvent) return;
      // そのうえでカートを取り直し、ギフトの数量と小計の表示を合わせ直す。
      syncSoon();
    });
  });

  // ドロワーの中身はテーマが後から差し込むので、描画され次第かけ直す
  function watchDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;
    var wrap = drawer.querySelector('[data-products]');
    if (!wrap) return;
    new MutationObserver(function () {
      // 差し込まれた瞬間に隠す。fetch を待つとその間だけ全行が見えてしまう。
      applyRowVisibility();
      syncSoon();
    }).observe(wrap, { childList: true, subtree: true });
  }

  function start() {
    watchDrawer();
    guardCartInPopup();
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.lfGift = { sync: sync, render: render };
})();
